/* ──────────────────────────────────────────────
   DIVINE FUTURISM — obsidian void · celestial gold · ethereal violet
────────────────────────────────────────────── */
export const theme = {
  // cosmic void surfaces
  bg: "#06060B", // obsidian black
  bgDeep: "#040408",
  bgPanel: "rgba(20, 16, 38, 0.55)", // translucent stained-glass panel
  glass: "rgba(28, 22, 50, 0.40)",
  glassHi: "rgba(40, 32, 70, 0.55)",
  veil: "#0B0A18", // deep indigo wash

  // luminous lines / borders
  border: "rgba(201, 168, 76, 0.18)", // faint gold
  borderHi: "rgba(201, 168, 76, 0.45)",
  borderViolet: "rgba(107, 63, 160, 0.35)",

  // celestial palette
  gold: "#C9A84C", // celestial gold
  goldSoft: "#E4CE8A",
  violet: "#6B3FA0", // ethereal violet
  indigo: "#3B2E78", // electric indigo
  white: "#F5F1E6", // divine white (warm)

  // text
  text: "#F5F1E6",
  textMuted: "rgba(245, 241, 230, 0.62)",
  textFaint: "rgba(245, 241, 230, 0.38)",

  // glows
  goldGlow: "rgba(201, 168, 76, 0.30)",
  violetGlow: "rgba(107, 63, 160, 0.35)",
  haloGlow: "rgba(228, 206, 138, 0.25)",

  fonts: {
    serif: "'Cormorant Garamond', 'Playfair Display', Georgia, serif",
    sans: "'Inter', system-ui, sans-serif",
    mono: "'JetBrains Mono', monospace",
  },

  bp: {
    sm: "(max-width: 600px)",
    md: "(max-width: 860px)",
    lg: "(max-width: 1100px)",
  },
};

export const darkTheme = theme;
export const lightTheme = theme;
